/**
 * Floating island container for the toolbar.
 *
 * A centered pill-shaped bar with shadow and blur effects.
 * Wraps primary actions and status controls.
 * Implements roving tabindex for keyboard navigation (Arrow Left/Right).
 */

import type { ReactNode } from "react";
import { useStyles } from "./dockToolbar.styles";
import { useRovingTabindex } from "./hooks/useRovingTabindex";

export interface DockBarProps {
  children: ReactNode;
}

export const DockBar: React.FC<DockBarProps> = ({ children }) => {
  const styles = useStyles();
  const { toolbarRef, handleKeyDown, handleFocus } = useRovingTabindex();

  return (
    <div
      ref={toolbarRef}
      className={styles.island}
      role="toolbar"
      aria-label="Canvas toolbar"
      aria-orientation="horizontal"
      onKeyDown={handleKeyDown}
      onFocusCapture={handleFocus}
    >
      {children}
    </div>
  );
};
